import { getScheduledTime } from '../../../../services/bidProfile';

export const sequentialScheduleStartDate = 'sequentialScheduleStartDate';

/**
 * @param {ManagerAppData.IEmployee} employee
 * @param {{[Key: string]: number}} rankedEmployeesDictionary
 * @param {boolean} isSequential
 * @param {BidProfile.ISequentialEmployeeSchedule} sequentialSchedule
 * @returns {BidProfile.IEmployeeListSummaryRow}
 */
export const mapToEmployeeListSummaryRow = (employee, rankedEmployeesDictionary, isSequential, sequentialSchedule, lockedEmployeeIds) => {
    const hasScheduledDateAndTime = isSequential && sequentialSchedule[employee.employeeId];
    return {
        ...employee,
        isLocked: lockedEmployeeIds.includes(employee.employeeId),
        rank: rankedEmployeesDictionary[employee.employeeId],
        scheduledDateAndTime: getScheduledTime(sequentialSchedule[employee.employeeId], hasScheduledDateAndTime),
        [sequentialScheduleStartDate]: hasScheduledDateAndTime ? sequentialSchedule[employee.employeeId].employeeSubmissionStartDate : null,
    };
};
